import { FormArray, FormBuilder } from "react-reactive-form";

/**
 * Populate a FormArray control with valueHelper values
 */
export const populateValueHelperArray = (wizardForm, controlName, values) => {
  if (!controlName) {
    return;
  }

  let arrayControl;
  if (
    wizardForm.contains(controlName) &&
    wizardForm.get(controlName) instanceof FormArray
  ) {
    arrayControl = wizardForm.get(controlName);
    while (arrayControl.length > 0) {
      arrayControl.removeAt(0);
    }
  } else {
    arrayControl = new FormArray([]);
    wizardForm.setControl(controlName, arrayControl);
  }

  if (!values) {
    return;
  }

  const normalizedValues = Array.isArray(values) ? values : [values];

  normalizedValues.forEach(item => {
    let value = "";

    if (typeof item === "string") {
      value = item;
    } else if (item && typeof item === "object" && !Array.isArray(item)) {
      if (item.valueHelper !== undefined && item.valueHelper !== null) {
        value = item.valueHelper;
      } else if (item.value !== undefined && item.value !== null) {
        value = item.value;
      } else if (item.Comparator || item.Analyte) {
        value = item.Comparator || item.Analyte || "";
      }
    }

    if (value !== undefined && value !== null) {
      const trimmedValue = String(value).trim();
      if (trimmedValue !== "") {
        const group = FormBuilder.group({ valueHelper: [trimmedValue] });
        // Set a unique meta.key so QuestionsAnswersArray's React key changes
        // when items are replaced, forcing FieldControl to remount with the
        // restored value rather than keeping a stale subscription.
        group.meta = { key: `pvh_${controlName}_${arrayControl.length}` };
        arrayControl.push(group);
      }
    }
  });

  // Ensure at least one empty item so the UI renders an initial form control
  // even when the restored value is an empty array [].
  if (arrayControl.length === 0) {
    const emptyGroup = FormBuilder.group({ valueHelper: [""] });
    emptyGroup.meta = { key: `pvh_${controlName}_default` };
    arrayControl.push(emptyGroup);
  }
};

/**
 * Extract array values from form arrays
 */
export const extractArrayValues = formArray => {
  if (!formArray) return [];
  // Handle non-array values (e.g. single string/object restored by merge logic)
  if (!Array.isArray(formArray)) {
    formArray = [formArray];
  }
  return formArray
    .map(item => {
      if (typeof item === "object" && item !== null) {
        // Handle objects with valueHelper property
        if (
          item.valueHelper !== undefined &&
          item.valueHelper !== null &&
          item.valueHelper !== ""
        ) {
          return item.valueHelper;
        }
        // Handle arrays of values
        if (Array.isArray(item) && item.length > 0) {
          return item;
        }
        // Return the object itself if it has meaningful content
        return Object.values(item).some(
          v => v !== null && v !== "" && v !== undefined
        )
          ? item
          : null;
      }
      return item !== null && item !== "" ? item : null;
    })
    .filter(item => item !== null && item !== "");
};
